import React, { useState, useContext } from 'react';
import styled from 'styled-components';

import PagePositionContext from '../../../context/PagePositionContext';

const StyledLazyField = styled.div`
  height: 100%;
`;

const FieldLazyLoader = ({ children }) => {

  const [ref, setRef] = useState(null);
  const { top, bottom } = useContext(PagePositionContext);

  const fieldRect = ref ? ref.getBoundingClientRect() : {};
  const fieldTop = fieldRect.top;
  const fieldBottom = fieldRect.bottom;

  const isVisible = fieldTop <= (bottom + 500) && fieldBottom >= (top - 500);

  return (
    <StyledLazyField
      ref={(e) => {
        if (!e) return;
        if (!ref) setRef(e);
      }}
    >
      {isVisible ? children : null}
    </StyledLazyField>
  );
};

export default FieldLazyLoader;
